import React from "react";
import { Descriptions, Typography } from "antd";
const { Title } = Typography;

const AnswerBotAgentSetup = ({ resource }) => {
  return (
    <>
      <Title level={4}>Order Information</Title>
      <Descriptions column={1} layout="vertical" size="small">
        <Descriptions.Item label="Agent Name">{resource.agent_name}</Descriptions.Item>
        <Descriptions.Item label="Agent ID">{resource.agent_id}</Descriptions.Item>
        <Descriptions.Item label="Country">{resource.country}</Descriptions.Item>
        <Descriptions.Item label="Preferred Area Codes">{resource.preferred_area_codes}</Descriptions.Item>
        { resource.transfer_number && 
          <>
            <Descriptions.Item label="Transfer number">{resource.transfer_number}</Descriptions.Item> 
            <Descriptions.Item label="Transfer number description">{resource.transfer_number_description}</Descriptions.Item>
          </>
        }
      </Descriptions>
    </>
  );
};

export default AnswerBotAgentSetup;
